import { HealthBadgeWithTooltip } from '@/features/insights-dashboard/components/shared/HealthBadgeWithTooltip';
import { useVisibleItemHealth } from '../context/VisibleHealthContext';
import type { ItemsTableRow } from '../types';
import { CellTextSkeleton } from './withSkeleton';

export const HealthTableCell = ({ row }: { row: ItemsTableRow }) => {
  const health = useVisibleItemHealth(row.id);

  if (health === undefined) return <CellTextSkeleton />;
  if (health === null) return null;

  return (
    <div className="overflow-hidden w-full min-w-0">
      <HealthBadgeWithTooltip
        healthLevel={health.healthLevel}
        healthTypes={health.risks.map((risk) => risk.key)}
        className="max-w-full"
      />
    </div>
  );
};
